import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faTrash, 
    faSync, 
    faSearch, 
    faBook, 
    faEye, 
    faReply, 
    faCheckCircle, 
    faClock, 
    faExclamationTriangle,
    faFileAlt,
    faPrint,
    faTimes,
    faFilter,
    faUser,
    faBuilding,
    faPhone,
    faEnvelope,
    faCalendarAlt
} from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './LibroReclamacionesData.css';

export default function LibroReclamacionesData() {
    const [reclamos, setReclamos] = useState([]);
    const [stats, setStats] = useState({
        total: 0,
        pendientes: 0,
        enProceso: 0,
        atendidos: 0,
        totalReclamos: 0,
        totalQuejas: 0
    });
    const [loading, setLoading] = useState(true);

    // Filtros
    const [filtroTexto, setFiltroTexto] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [filtroTipo, setFiltroTipo] = useState('');

    // Modal Detalle
    const [modalDetalle, setModalDetalle] = useState(false);
    const [reclamoDetalle, setReclamoDetalle] = useState(null);

    // Modal Responder / Estado
    const [modalResponder, setModalResponder] = useState(false);
    const [reclamoRespondiendo, setReclamoRespondiendo] = useState(null);
    const [nuevoEstado, setNuevoEstado] = useState('Pendiente');
    const [textoRespuesta, setTextoRespuesta] = useState('');
    const [guardandoRespuesta, setGuardandoRespuesta] = useState(false);

    useEffect(() => {
        cargarReclamos();
    }, [filtroEstado, filtroTipo]);

    const cargarReclamos = () => {
        setLoading(true);
        let url = `${baseURL}/libroReclamacionesGet.php?`;
        if (filtroEstado) url += `estado=${encodeURIComponent(filtroEstado)}&`;
        if (filtroTipo) url += `tipoReclamacion=${encodeURIComponent(filtroTipo)}&`;
        if (filtroTexto) url += `buscar=${encodeURIComponent(filtroTexto)}&`;

        fetch(url)
            .then(res => res.json())
            .then(data => {
                setReclamos(data.reclamos || []);
                if (data.stats) {
                    setStats(data.stats);
                }
                setLoading(false);
            })
            .catch(err => {
                console.error('Error al cargar reclamaciones:', err);
                setLoading(false);
            });
    };

    const handleBuscar = (e) => {
        e.preventDefault();
        cargarReclamos();
    };

    const abrirDetalle = (r) => {
        setReclamoDetalle(r);
        setModalDetalle(true);
    };

    const abrirResponder = (r) => {
        setReclamoRespondiendo(r);
        setNuevoEstado(r.estado || 'Pendiente');
        setTextoRespuesta(r.respuesta || '');
        setModalResponder(true);
    };

    const guardarRespuesta = (e) => {
        e.preventDefault();
        if (!reclamoRespondiendo) return;

        setGuardandoRespuesta(true);
        fetch(`${baseURL}/libroReclamacionesPut.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                idReclamo: reclamoRespondiendo.idReclamo,
                estado: nuevoEstado,
                respuesta: textoRespuesta
            })
        })
            .then(res => res.json())
            .then(data => {
                setGuardandoRespuesta(false);
                if (data.success) {
                    setModalResponder(false);
                    cargarReclamos();
                    Swal.fire({
                        title: '¡Actualizado!',
                        text: 'El estado y respuesta de la reclamación han sido actualizados.',
                        icon: 'success',
                        timer: 2000
                    });
                } else {
                    Swal.fire('Error', data.error || 'No se pudo actualizar.', 'error');
                }
            })
            .catch(err => {
                setGuardandoRespuesta(false);
                console.error('Error al actualizar:', err);
                Swal.fire('Error', 'No se pudo conectar con el servidor.', 'error');
            });
    };

    const eliminarReclamo = (idReclamo, codigo) => {
        Swal.fire({
            title: '¿Eliminar reclamación?',
            text: `Se eliminará permanentemente la reclamación ${codigo}. Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/libroReclamacionesDelete.php`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ idReclamo })
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.success) {
                            cargarReclamos();
                            Swal.fire('Eliminado', 'La reclamación ha sido eliminada.', 'success');
                        } else {
                            Swal.fire('Error', data.error || 'No se pudo eliminar.', 'error');
                        }
                    })
                    .catch(err => {
                        console.error('Error al eliminar:', err);
                        Swal.fire('Error', 'No se pudo conectar con el servidor.', 'error');
                    });
            }
        });
    };

    return (
        <div className="reclamosDataContainer">
            {/* Cabecera y Título */}
            <div className="reclamosHeaderTop">
                <div>
                    <h2>Libro de Reclamaciones</h2>
                    <p>Gestiona, responde y supervisa los reclamos y quejas virtuales registrados conforme a Ley N° 29571.</p>
                </div>
                <button type="button" onClick={cargarReclamos} className="btn-refresh-reclamos" title="Actualizar">
                    <FontAwesomeIcon icon={faSync} spin={loading} /> Actualizar
                </button>
            </div>

            {/* Tarjetas de Métricas */}
            <div className="reclamosStatsGrid">
                <div className="statCard total">
                    <div className="statIconWrap">
                        <FontAwesomeIcon icon={faBook} />
                    </div>
                    <div className="statInfo">
                        <span className="statLabel">Total Registrados</span>
                        <strong className="statNumber">{stats.total || 0}</strong>
                    </div>
                </div>

                <div className="statCard pendientes">
                    <div className="statIconWrap">
                        <FontAwesomeIcon icon={faClock} />
                    </div>
                    <div className="statInfo">
                        <span className="statLabel">Pendientes</span>
                        <strong className="statNumber">{stats.pendientes || 0}</strong>
                    </div>
                </div>

                <div className="statCard enProceso">
                    <div className="statIconWrap">
                        <FontAwesomeIcon icon={faSync} />
                    </div>
                    <div className="statInfo">
                        <span className="statLabel">En Trámite</span>
                        <strong className="statNumber">{stats.enProceso || 0}</strong>
                    </div>
                </div>

                <div className="statCard atendidos">
                    <div className="statIconWrap">
                        <FontAwesomeIcon icon={faCheckCircle} />
                    </div>
                    <div className="statInfo">
                        <span className="statLabel">Atendidos</span>
                        <strong className="statNumber">{stats.atendidos || 0}</strong>
                    </div>
                </div>
            </div>

            {/* Barra de Filtros y Búsqueda */}
            <div className="reclamosFiltersBar">
                <form onSubmit={handleBuscar} className="reclamosSearchBox">
                    <FontAwesomeIcon icon={faSearch} className="searchIcon" />
                    <input 
                        type="text" 
                        placeholder="Buscar por código, nombre, documento, correo o teléfono..." 
                        value={filtroTexto}
                        onChange={(e) => setFiltroTexto(e.target.value)}
                    />
                    <button type="submit">Buscar</button>
                </form>

                <div className="reclamosSelectsWrap">
                    <div className="selectItem">
                        <label>Estado:</label>
                        <select value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                            <option value="">Todos los Estados</option>
                            <option value="Pendiente">Pendiente</option>
                            <option value="En Proceso">En Proceso</option>
                            <option value="Atendido">Atendido</option>
                            <option value="Rechazado">Rechazado</option>
                        </select>
                    </div>

                    <div className="selectItem">
                        <label>Tipo:</label>
                        <select value={filtroTipo} onChange={(e) => setFiltroTipo(e.target.value)}>
                            <option value="">Todos los Tipos</option>
                            <option value="Reclamo">Reclamo</option>
                            <option value="Queja">Queja</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* Tabla de Reclamaciones */}
            <div className="reclamosTableWrapper">
                {loading ? (
                    <div className="reclamosLoadingState">
                        <FontAwesomeIcon icon={faSync} spin size="2x" />
                        <p>Cargando libro de reclamaciones...</p>
                    </div>
                ) : reclamos.length === 0 ? (
                    <div className="reclamosEmptyState">
                        <FontAwesomeIcon icon={faFileAlt} size="3x" />
                        <h3>No se encontraron reclamaciones</h3>
                        <p>No hay registros que coincidan con los filtros seleccionados.</p>
                    </div>
                ) : (
                    <table className="reclamosTable">
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Fecha</th>
                                <th>Consumidor</th>
                                <th>Documento</th>
                                <th>Tipo</th>
                                <th>Bien</th>
                                <th>Estado</th>
                                <th style={{ textAlign: 'center' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reclamos.map((r) => {
                                const estadoBadgeClass = 
                                    r.estado === 'Atendido' ? 'badge-atendido' :
                                    r.estado === 'En Proceso' ? 'badge-enproceso' :
                                    r.estado === 'Rechazado' ? 'badge-rechazado' : 'badge-pendiente';

                                const tipoBadgeClass = r.tipoReclamacion === 'Queja' ? 'badge-queja' : 'badge-reclamo';

                                return (
                                    <tr key={r.idReclamo}>
                                        <td>
                                            <span className="codigoPill">{r.codigo}</span>
                                        </td>
                                        <td className="fechaText">
                                            {r.fecha ? r.fecha.split(' ')[0] : ''}
                                        </td>
                                        <td>
                                            <div className="consumidorCol">
                                                <strong>{r.nombres} {r.apellidos}</strong>
                                                <span>{r.email}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <span className="docText">{r.tipoDocumento}: {r.numeroDocumento}</span>
                                        </td>
                                        <td>
                                            <span className={`tipoBadge ${tipoBadgeClass}`}>
                                                {r.tipoReclamacion}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="bienText">{r.tipoBien}</span>
                                        </td>
                                        <td>
                                            <span className={`estadoBadge ${estadoBadgeClass}`}>
                                                {r.estado}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="actionButtonsWrap">
                                                <button 
                                                    type="button" 
                                                    className="btn-action view" 
                                                    onClick={() => abrirDetalle(r)}
                                                    title="Ver Detalle Completo"
                                                >
                                                    <FontAwesomeIcon icon={faEye} />
                                                </button>
                                                <button 
                                                    type="button" 
                                                    className="btn-action reply" 
                                                    onClick={() => abrirResponder(r)}
                                                    title="Responder / Actualizar Estado"
                                                >
                                                    <FontAwesomeIcon icon={faReply} />
                                                </button>
                                                <button 
                                                    type="button" 
                                                    className="btn-action delete" 
                                                    onClick={() => eliminarReclamo(r.idReclamo, r.codigo)}
                                                    title="Eliminar Reclamación"
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>

            {/* ==================================================== */}
            {/* MODAL DETALLE COMPLETO                               */}
            {/* ==================================================== */}
            {modalDetalle && reclamoDetalle && (
                <div className="modalReclamoOverlay" onClick={() => setModalDetalle(false)}>
                    <div className="modalReclamoContent modalDetalleContent" onClick={(e) => e.stopPropagation()}>
                        <div className="modalReclamoHeader">
                            <div className="headerLeft">
                                <h3>Hoja de Reclamación: {reclamoDetalle.codigo}</h3>
                                <span className="fechaModal">Registrado el {reclamoDetalle.fecha}</span>
                            </div>
                            <button type="button" className="btnCloseModal" onClick={() => setModalDetalle(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <div className="modalReclamoBody">
                            {/* Bloque 1: Consumidor */}
                            <div className="detalleSectionBlock">
                                <h4>1. Consumidor Reclamante</h4>
                                <div className="detalleGrid">
                                    <div><strong>Nombre:</strong> {reclamoDetalle.nombres} {reclamoDetalle.apellidos}</div>
                                    <div><strong>Tipo Persona:</strong> {reclamoDetalle.tipoPersona}</div>
                                    <div><strong>Documento:</strong> {reclamoDetalle.tipoDocumento} - {reclamoDetalle.numeroDocumento}</div>
                                    <div><strong>Teléfono:</strong> {reclamoDetalle.telefono}</div>
                                    <div><strong>Correo:</strong> {reclamoDetalle.email}</div>
                                    <div><strong>Ubicación:</strong> {reclamoDetalle.distrito}, {reclamoDetalle.provincia}, {reclamoDetalle.departamento}</div>
                                    <div className="gridFull"><strong>Dirección:</strong> {reclamoDetalle.direccion}</div>
                                    {reclamoDetalle.esMenorEdad ? (
                                        <div className="gridFull text-warning">
                                            <strong>Menor de Edad:</strong> Sí | Apoderado: {reclamoDetalle.nombreApoderado || 'No especificado'}
                                        </div>
                                    ) : null}
                                </div>
                            </div>

                            {/* Bloque 2: Bien Contratado */}
                            <div className="detalleSectionBlock">
                                <h4>2. Bien Contratado</h4>
                                <div className="detalleGrid">
                                    <div><strong>Tipo:</strong> {reclamoDetalle.tipoBien}</div>
                                    <div><strong>Monto Reclamado:</strong> S/ {reclamoDetalle.montoReclamado ? Number(reclamoDetalle.montoReclamado).toFixed(2) : '0.00'}</div>
                                    <div className="gridFull"><strong>Descripción:</strong> {reclamoDetalle.descripcionBien}</div>
                                </div>
                            </div>

                            {/* Bloque 3: Reclamación */}
                            <div className="detalleSectionBlock">
                                <h4>3. Detalle de la Reclamación ({reclamoDetalle.tipoReclamacion})</h4>
                                <div className="detalleTextWrap">
                                    <strong>Hechos expuestos:</strong>
                                    <p>{reclamoDetalle.detalle}</p>
                                </div>
                                <div className="detalleTextWrap">
                                    <strong>Pedido concreto del reclamante:</strong>
                                    <p>{reclamoDetalle.pedido}</p>
                                </div>
                            </div>

                            {/* Bloque 4: Respuesta de la Empresa */}
                            <div className="detalleSectionBlock">
                                <h4>4. Estado y Respuesta de la Empresa</h4>
                                <div className="detalleGrid">
                                    <div><strong>Estado Actual:</strong> {reclamoDetalle.estado}</div>
                                    <div><strong>Fecha de Respuesta:</strong> {reclamoDetalle.fechaRespuesta || 'Aún sin respuesta'}</div>
                                </div>
                                {reclamoDetalle.respuesta ? (
                                    <div className="detalleTextWrap" style={{ marginTop: '8px' }}>
                                        <strong>Respuesta Formal:</strong>
                                        <p style={{ background: '#ecfdf5', borderColor: '#a7f3d0' }}>{reclamoDetalle.respuesta}</p>
                                    </div>
                                ) : (
                                    <p className="sinRespuestaAviso">Aún no se ha registrado una respuesta para esta reclamación.</p>
                                )}
                            </div>
                        </div>

                        <div className="modalReclamoFooter">
                            <button type="button" className="btnModalSec" onClick={() => setModalDetalle(false)}>
                                Cerrar
                            </button>
                            <button 
                                type="button" 
                                className="btnModalPri" 
                                onClick={() => {
                                    setModalDetalle(false);
                                    abrirResponder(reclamoDetalle);
                                }}
                            >
                                <FontAwesomeIcon icon={faReply} /> Responder / Cambiar Estado
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ==================================================== */}
            {/* MODAL RESPONDER / CAMBIAR ESTADO                     */}
            {/* ==================================================== */}
            {modalResponder && reclamoRespondiendo && (
                <div className="modalReclamoOverlay" onClick={() => setModalResponder(false)}>
                    <div className="modalReclamoContent modalResponderContent" onClick={(e) => e.stopPropagation()}>
                        <div className="modalReclamoHeader">
                            <div className="headerLeft">
                                <h3>Responder Reclamación: {reclamoRespondiendo.codigo}</h3>
                                <span className="fechaModal">Consumidor: {reclamoRespondiendo.nombres} {reclamoRespondiendo.apellidos}</span>
                            </div>
                            <button type="button" className="btnCloseModal" onClick={() => setModalResponder(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={guardarRespuesta}>
                            <div className="modalReclamoBody">
                                <div className="formGroupModal">
                                    <label>Estado de la Reclamación *</label>
                                    <select 
                                        value={nuevoEstado} 
                                        onChange={(e) => setNuevoEstado(e.target.value)}
                                        className="modalInput"
                                    >
                                        <option value="Pendiente">Pendiente (En espera de revisión)</option>
                                        <option value="En Proceso">En Proceso (En evaluación / trámite)</option>
                                        <option value="Atendido">Atendido (Respuesta formal emitida)</option>
                                        <option value="Rechazado">Rechazado (No procede)</option>
                                    </select>
                                </div>

                                <div className="formGroupModal">
                                    <label>Respuesta Formal de la Empresa / Notas de Resolución</label>
                                    <textarea 
                                        rows="6"
                                        value={textoRespuesta}
                                        onChange={(e) => setTextoRespuesta(e.target.value)}
                                        placeholder="Escriba la respuesta, acuerdo o resolución brindada al consumidor conforme a la ley..."
                                        className="modalTextarea"
                                    />
                                    <small className="helpText">
                                        Esta respuesta queda registrada en el sistema y sirve de constancia de cumplimiento ante las autoridades.
                                    </small>
                                </div>
                            </div>

                            <div className="modalReclamoFooter">
                                <button type="button" className="btnModalSec" onClick={() => setModalResponder(false)}>
                                    Cancelar
                                </button>
                                <button type="submit" disabled={guardandoRespuesta} className="btnModalPri">
                                    {guardandoRespuesta ? 'Guardando...' : 'Guardar y Actualizar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
